module.exports = __webpack_public_path__ + "static/media/check-square-light.1705b2ad.svg";